export default {"src":"/_next/static/media/scrollie.2a7f1d31.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};